import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

const Hero = (props) => {
  return (
    <section className="relative h-dvh transition-all duration-300">
      <GatsbyImage
        alt={props.title}
        image={props.backgroundHero}
        className="h-full w-full"
      />
      <div className="absolute left-5 right-5 flex w-[min(840px,90vw)] flex-col items-start gap-y-1 bg-white/95 px-5 py-12 max-lg:bottom-16 md:bottom-3 md:left-3 lg:bottom-10 lg:p-10">
        <h1 className="text-pretty text-3xl font-bold tracking-tight sm:text-6xl">
          {props.title}
        </h1>
        <hr />
        {props.subtitle && <p>{props.subtitle}</p>}
        {props.children}
      </div>
    </section>
  )
}

export default Hero
